import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const addonsEmceePublicRoute: InvariantJiraRoute = {
	name: 'addons-emcee-public',
	path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover',
};
